import { createSlice } from "@reduxjs/toolkit";
import { initialAutomobileCertificateofInsuranceState } from "./automobileCertificateofInsurance.types";
import { fetchAutomobileCertificateOfInsuranceList } from "./automobileCertificateofInsuranceActions";
import { LoadState } from "../../constants/enums";

const automobileCertificateofInsuranceSlice = createSlice({
  name: "automobileCertificateofInsurance",
  initialState: initialAutomobileCertificateofInsuranceState,
  reducers: {
    clearAutomobileCertificateofInsuranceState: (state) => {
      return initialAutomobileCertificateofInsuranceState;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(
      fetchAutomobileCertificateOfInsuranceList.pending,
      (state) => {
        state.loading = LoadState.InProgress;
        state.certificateOfInsuranceList = [];
      },
    );
    builder.addCase(
      fetchAutomobileCertificateOfInsuranceList.fulfilled,
      (state, action) => {
        state.loading = LoadState.Loaded;
        state.certificateOfInsuranceList = action.payload.data;
        state.totalRecords = action.payload.totalRecords;
      },
    );
    builder.addCase(
      fetchAutomobileCertificateOfInsuranceList.rejected,
      (state) => {
        state.loading = LoadState.Failed;
      },
    );
  },
});

export const { clearAutomobileCertificateofInsuranceState } =
  automobileCertificateofInsuranceSlice.actions;

export const automobileCertificateofInsuranceReducer = automobileCertificateofInsuranceSlice.reducer;
